"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TsFormGroup = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var FormGroup_1 = __importDefault(require("react-bootstrap/lib/FormGroup"));
var techsee_base_component_1 = require("../../_shared/techsee-base-component");
var simple_1 = require("../labels/simple");
var with_icon_1 = require("../labels/with-icon");
require("./styles.scss");
var TsFormGroup = (function (_super) {
    __extends(TsFormGroup, _super);
    function TsFormGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TsFormGroup.prototype.renderInternal = function () {
        var _a = this.props, uid = _a.uid, label = _a.label, className = _a.className, isRequired = _a.isRequired;
        this.addCssClass(className);
        this.addCssClassIf('required', isRequired);
        this.addCssClassIf('no-label', (0, isEmpty_1.default)(label));
        return (react_1.default.createElement(FormGroup_1.default, { id: uid + '-field-container', className: this.renderCssClasses(), validationState: this.validationState },
            !(0, isEmpty_1.default)(label) && this.getLabelComponent(),
            this.props.children,
            react_1.default.createElement("div", { className: this.errorMessages ? 'errors-container' : 'errors-container-empty' }, this.errorMessages)));
    };
    TsFormGroup.prototype.getLabelComponent = function () {
        var _a = this.props, iconName = _a.iconName, labelFor = _a.labelFor, label = _a.label;
        return !iconName ? (react_1.default.createElement(simple_1.SimpleLabel, { labelFor: labelFor, className: 'control-label' },
            label,
            ":")) : (react_1.default.createElement(with_icon_1.LabelWithIcon, { labelFor: labelFor, icon: iconName, className: 'control-label' },
            label,
            ":"));
    };
    Object.defineProperty(TsFormGroup.prototype, "validationState", {
        get: function () {
            return this.props.showErrors && this.props.errors && this.props.errors.length > 0 ? 'error' : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TsFormGroup.prototype, "errorMessages", {
        get: function () {
            var _a = this.props, errors = _a.errors, showErrors = _a.showErrors;
            return showErrors && errors
                ? errors.map(function (error, index) { return react_1.default.createElement("div", { key: index, dangerouslySetInnerHTML: { __html: error } }); })
                : null;
        },
        enumerable: false,
        configurable: true
    });
    TsFormGroup.defaultProps = {
        isRequired: false,
        label: '',
        labelFor: '',
        errors: [],
        showErrors: false,
        iconName: ''
    };
    TsFormGroup = __decorate([
        mobx_react_1.observer
    ], TsFormGroup);
    return TsFormGroup;
}(techsee_base_component_1.TechseeBaseComponent));
exports.TsFormGroup = TsFormGroup;
exports.default = TsFormGroup;
